<template>
  <div class="attachment">
    <div class="form-group">
      <label class="form-control-label">Field:</label>
      <select @input="updateField($event.target.value)" :value="fields[0].label" class="form-control form-control-sm">
        <option v-for="field in fields" :key="field.id">{{ field.label }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="form-control-label">Enter Value:</label>
      <input @input="updateFieldValue($event.target.value)" :value="currentNode.attachment.fieldValue" type="text" class="form-control form-control-sm">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formBase } from './mixins'

export default {
  mixins: [formBase],
  computed: {
    fields() {
      var fieldTree = []
      var f = this.dataGrid_options

      Object.keys(f).forEach(function(key) {
        var fieldsKey = f[key].meta
        var name = f[key].title

        var objectFields = []
        Object.keys(fieldsKey).forEach(function(k) {
          var label = name + ' / ' + fieldsKey[k].displayName
          var id = key + '.' + k
          if (fieldsKey[k].lookUpTable)
            id = key + '.' + k + '.' + fieldsKey[k].lookUpTable
          objectFields.push({ id, label })
        })
        fieldTree.push.apply(fieldTree, objectFields)
      })
      return fieldTree
    },
  },
  methods: {
    updateField(field){
      let currentNode = Object.assign({}, this.currentNode)
      if (!currentNode.hasOwnProperty('attachment')) {
        currentNode['attachment'] = {}
      } 
      if (field) {
        currentNode.attachment['field'] = field
      }
      this.updateNode(currentNode)
    },
    updateFieldValue(value) {
      let currentNode = Object.assign({}, this.currentNode)
      if (!currentNode.hasOwnProperty('attachment')) {
        currentNode['attachment'] = {}
      }
      if (value) {
        currentNode.attachment['fieldValue'] = value
        this.updateNode(currentNode)
      } 
    }
  },

}
</script>
